export default "__VITE_ASSET__Bco9v5AI__"